<template>
  <v-toolbar color="grey lighten-4" light tile flat>
    <v-toolbar-title centered class="headline font-weight-bold">
      {{ client.first_name }}
      {{ client.last_name }}
    </v-toolbar-title>

    <div class="flex-grow-1"></div>

    <v-btn color="primary" :disabled="!canBeDeactivated">
      <v-icon>mdi-account-off</v-icon>
      Deactivate Account
    </v-btn>
  </v-toolbar>
</template>
<script>
export default {
  props: {
    client: { required: true },
  },
  computed: {
    canBeDeactivated() {
      return this.client.activated_at && this.client.api_url;
    },
  },
};
</script>
